import React from "react";
import siteLogo from "../../../assets/images/logo.png";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import useForm from "../../../hooks/useForm";
import { formValidate } from "../../../helpers/formValidate";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { login } from "../../../redux/slice/authSlice";
import { useDispatch } from "react-redux";

const validation = {
  email: [
    {
      type: "email",
      required: true,
      message: "Enter valid Email",
    },
  ],
  password: [
    {
      type: "password",
      minLength: 8,
      required: true,
      message:
        "Password must be strong (min 8 characters, including uppercase, lowercase, number, and symbol)",
    },
  ],
};
const AdminLogin = () => {
  const { loginPending } = useSelector((state) => state?.authProvider);
  const dispatch = useDispatch();
  const location = useLocation();

  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({ validationRules: validation });

  const navigate = useNavigate();
  const settings = useSelector((state) => state?.settings?.data);

  const handleClick = () => {
    navigate("/admin/forgot-password", {
      state: "admin",
    });
  };

  return (
    <div className="w-full min-h-screen bg-slate-50 flex items-center justify-center py-3 px-5">
      <div className="w-full max-w-md xl:max-w-md bg-white py-10 shadow-md rounded-2xl border border-red-700 ">
        <div className="flex min-h-full flex-1 flex-col justify-center px-2 py-4 lg:px-2">
          <div className="sm:mx-auto sm:w-full sm:max-w-sm">
            <img
              className="mx-auto h-12 w-auto"
              src={settings?.favicon?.url || siteLogo}
              alt="Your Company"
            />
            <h2 className="mt-1 uppercase text-center text-md font-bold leading-9 tracking-tight text-red-700">
              Admin Login
            </h2>
            <h2 className="mt-1 text-center text-base font-semibold leading-9 tracking-tight text-black">
              Authorized Personnel Only.
            </h2>
          </div>

          <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
            <form
              onSubmit={(event) =>
                handleSubmit(event, (val) =>
                  dispatch(
                    login({
                      ...val,
                      type: "admin",
                      redirect: "/admin/dashboard",
                      location,
                      navigate,
                    })
                  )
                )
              }
            >
              <div className="mt-2">
                <Input
                  label={"Email"}
                  inputPlaceholder={"Enter your email"}
                  labelClasses={"!text-xs"}
                  inputType={"text"}
                  value={values.email}
                  inputName={"email"}
                  onChange={handleChange}
                  {...formValidate(errors, "email")}
                />
              </div>

              <div>
                <div className="mt-2">
                  <Input
                    label={"Password"}
                    inputPlaceholder={"Enter your password"}
                    labelClasses={"!text-xs"}
                    inputType={"password"}
                    value={values.password}
                    inputName={"password"}
                    onChange={handleChange}
                    {...formValidate(errors, "password")}
                  />
                </div>
              </div>

              <div className="mt-2">
                <Button
                  loading={loginPending}
                  buttonHasLink={false}
                  buttonType={"submit"}
                  buttonLabel={"Log in"}
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-light fa-right-to-bracket"}
                  buttonClasses={
                    "w-full !text-white !bg-chestnut-rose !hover:bg-white !hover:text-chestnut-rose focus-visible:outline justify-center rounded-md border border-chestnut-rose"
                  }
                />
              </div>
              <div className="flex justify-end">
                <Button
                  buttonClasses={
                    "!justify-right !bg-transparent !text-slate-500 border-none"
                  }
                  buttonHasLink={false}
                  buttonType={"button"}
                  buttonLabel={"Forgot Password?"}
                  buttonFunction={handleClick}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
